module.exports = __webpack_public_path__ + "img/fondo-flextd-login.128f6b27.webp";